import { Close } from '@mui/icons-material';
import { Box, Button, IconButton, Modal, Pagination } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';

export const CustomModal = ({
  handleClose,
  open,
  downloadExcel,
  columns,
  rows,
  sortModel,
  setSortModel,
  paginationChange,
  page,
  count,
  selectedTransportation,
  isMobile,
  allCardsByTransportation,
  resetAllLayerExceptOne,
}) => {
  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        style={{
          overflow: 'auto',
          height: isMobile ? '500px' : '720px',
          width: isMobile ? '90%' : '902px',
          outline: 'none',
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          backgroundColor: 'white',
          boxShadow: 24,
          padding: 10,
          borderRadius: 10,
        }}
      >
        <div className="flex justify-between  items-end py-2 px-1">
          <div className="flex flex-col ">
            <h1 className="text-lg font-semibold">
              {selectedTransportation?.transportation?.content} Görevi Kart
              Raporu
            </h1>
            <h2 className="text-sm">
              {selectedTransportation?.transportation?.vehicle?.id}|{' '}
              {selectedTransportation?.transportation?.driver?.id} |{' '}
              {Math.round(
                selectedTransportation?.transportation?.totalDistance / 1000,
              )}
              km |{' '}
              {Math.round(
                selectedTransportation?.transportation?.totalDuration / 60,
              )}
              dk
            </h2>
          </div>
          <IconButton component="span" onClick={() => handleClose(false)}>
            <Close />
          </IconButton>
        </div>
        <Button
          className="livetracking-container-filter-area-filter-button"
          variant="contained"
          sx={{ backgroundColor: '#2e3448', marginBottom: 2 }}
          onClick={downloadExcel}
        >
          Dışa Aktar
        </Button>
        <Button
          className="livetracking-container-filter-area-filter-button"
          variant="contained"
          sx={{ backgroundColor: '#2e3448', marginBottom: 2 }}
          onClick={() => {
            resetAllLayerExceptOne('LCards', allCardsByTransportation);
          }}
        >
          Tümünü Haritada Göster
        </Button>

        <div className="flex items-center flex-col justify-between ">
          <div className="w-full">
            <DataGrid
              rows={rows}
              sx={{ height: '100%' }}
              columns={columns}
              rowHeight={48}
              hideFooter
              showColumnRightBorder
              sortingMode="server"
              disableColumnFilter
              sortModel={sortModel}
              onSortModelChange={setSortModel}
            />
          </div>
          <div className=" py-1 my-1 flex justify-center ">
            <Pagination
              page={page + 1}
              onChange={paginationChange}
              count={count}
              color="primary"
              size="small"
            />
          </div>
        </div>
      </Box>
    </Modal>
  );
};
